import { ImageAttribution } from "@/components/ImageAttribution";
import { ImageSlider } from "@/components/ImageSlider";

export const ImageSection = ({
  section,
}: {
  section: Travelguide.POISection.Image;
}) => (
  <section className="flex flex-col gap-5" id="impressionen">
    <header className="px-4 md:px-6">
      <h2>Impressionen</h2>
    </header>
    <ImageSlider images={section.children} />
    <ImageAttribution images={section.children} />
  </section>
);
